import { __extends } from "tslib";
import * as React from 'react';
import { findDOMNode } from 'react-dom';
var ClickOutside = /** @class */ (function (_super) {
    __extends(ClickOutside, _super);
    function ClickOutside() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOuterClick = function (event) {
            var node = findDOMNode(_this);
            if (node && node !== event.target && !node.contains(event.target)) {
                _this.props.onOuterClick(event);
            }
        };
        return _this;
    }
    ClickOutside.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleOuterClick, true);
    };
    ClickOutside.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleOuterClick, true);
    };
    ClickOutside.prototype.render = function () {
        return React.Children.only(this.props.children);
    };
    return ClickOutside;
}(React.Component));
export { ClickOutside };
//# sourceMappingURL=click-outside.comp.js.map